import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=8dc217ae&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=8dc217ae&prod&scoped=true&lang=css&external"
import style1 from "./Admin.vue?vue&type=style&index=1&id=8dc217ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc217ae",
  null
  
)

export default component.exports